export const Blogs = [
     {
        id:1,
        name:"Solidity – Programming ERC-721 Token",
        tags:["Blockchain #Ethereum"],
        date:"",
        imgSrc:"https://pbs.twimg.com/profile_images/1476085383469445124/1ZRVN-QB_400x400.jpg",
        link:"https://www.geeksforgeeks.org/solidity-programming-erc-721-token/"
    },
    {
        id:2,
        name:"Difference Between Ethereum and Solana",
        tags:["Blockchain #Ethereum #Solana"],
        date:"",
        imgSrc:"https://pbs.twimg.com/profile_images/1476085383469445124/1ZRVN-QB_400x400.jpg",
        link:"https://www.geeksforgeeks.org/difference-between-ethereum-and-solana/"
    },
    {
        id:3,
        name:"Introduction to Polygon",
        tags:["Blockchain #Polygon"],
        date:"",
        imgSrc:"https://pbs.twimg.com/profile_images/1476085383469445124/1ZRVN-QB_400x400.jpg",
        link:"https://www.geeksforgeeks.org/introduction-to-polygon/"
    },
    {
        id:4,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
    {
        id:5,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
    {
        id:6,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""

    },
   
    {
        id:7,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
    {
        id:8,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
  
    {
        id:9,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
  
    {
        id:10,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
    {
        id:11,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    },
    {
        id:12,
        name:"Under Construction",
        tags:[""],
        date:"",
        imgSrc:"https://media.istockphoto.com/photos/webpage-under-construction-picture-id592021466",
        link:""
    }
  
] 
